import getOr from './getOr';
export default getOr(undefined);